<div class="appraisals-requests-container">

  <div class="list-header">
    <div class="header-title">
      <h3 translate>APPRAISAL_REQUESTS</h3>
      <span class="record-count"
        >{{ requests.length }} {{ "RECORDS" | translate }}</span
      >
    </div>
  </div>

  <div class="table-view">
    <p-table
      [value]="requests"
      [loading]="isLoading"
      styleClass="p-datatable-striped"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>{{ "MANAGER" | translate }}</th>
          <th>{{ "STATUS" | translate }}</th>
          <th>{{ "REQUESTED_DATE" | translate }}</th>
          <th>{{ "RESPONDED_DATE" | translate }}</th>
          <th>{{ "ASSIGNED_BY" | translate }}</th>
          <th>{{ "REJECTION_REASON" | translate }}</th>
          <th>{{ "ACTIONS" | translate }}</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-request>
        <tr>
          <td>{{ request.ManagerName }}</td>
          <td>{{ getStatusText(request.Status) | translate }}</td>
          <td>{{ request.RequestedAt | utcDate : "dd-MM-yyyy" }}</td>
          <td>{{ request.RespondedAt | utcDate : "dd-MM-yyyy" }}</td>
          <td>{{ request.RequestedBy?.Name }}</td>
          <td>{{ request.RejectionReason || "—" }}</td>
          <td>
            <div class="action-buttons" *ngIf="canRespond(request)">
              <button
                class="btn btn-sm btn-success"
                (click)="approveRequest(request)"
                [disabled]="respondingRequestId === request.Id"
              >
                <span translate>APPROVE</span>
              </button>
              <button
                class="btn btn-sm btn-danger"
                (click)="rejectRequest(request)"
                [disabled]="respondingRequestId === request.Id"
              >
                <span translate>REJECT</span>
              </button>
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="7" class="text-center">
            <div class="empty-state">
              <p class="empty-state-title" translate>
                APPRAISAL_EMPTY_REQUESTS_TITLE
              </p>
              <p class="empty-state-body" translate>
                APPRAISAL_EMPTY_REQUESTS_BODY
              </p>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<!-- Reject dialog -->
<p-dialog
  [(visible)]="rejectDialogVisible"
  [modal]="true"
  [draggable]="false"
  [dismissableMask]="false"
  [resizable]="false"
  [style]="{ width: '32rem' }"
  [header]="'REJECT' | translate"
  (onHide)="closeRejectDialog()"
>
  <div class="reject-dialog-content">
    <label for="rejectionReason" class="reject-dialog-label">
      {{ "REJECTION_REASON" | translate }}
      <span class="required-indicator">*</span>
    </label>

    <textarea
      id="rejectionReason"
      pTextarea
      rows="5"
      class="form-control"
      [(ngModel)]="rejectionReason"
      (blur)="rejectionReasonTouched = true"
      [placeholder]="'REJECTION_REASON' | translate"
    ></textarea>

    <small
      class="validation-message"
      *ngIf="rejectionReasonTouched && !rejectionReason.trim()"
    >
      * {{ "REQUIRED" | translate }}
    </small>
  </div>

  <ng-template pTemplate="footer">
    <div class="dialog-footer-actions">
      <button
        type="button"
        class="btn btn-outline-primary"
        (click)="closeRejectDialog()"
      >
        <span translate>CANCEL</span>
      </button>
      <button
        type="button"
        class="btn btn-danger"
        (click)="confirmRejectRequest()"
        [disabled]="
          !rejectionReason.trim() ||
          (requestToReject && respondingRequestId === requestToReject.Id)
        "
      >
        <i
          *ngIf="requestToReject && respondingRequestId === requestToReject.Id"
          class="fa fa-spinner fa-spin m-r-1"
          aria-hidden="true"
        ></i>
        <span translate>REJECT</span>
      </button>
    </div>
  </ng-template>
</p-dialog>

<p-confirmDialog [style]="{ width: '450px' }"></p-confirmDialog>
